<template>
  <div class="page" style="height: 100vh">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">登录</h2>
        <div class="weui-form__desc">爱精益网页版</div>
      </div>
      <div class="weui-form__control-area">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
              <div class="weui-cell__bd">
                <input id="phone_number_input" v-model="phoneNumber" autofocus class="weui-input"
                       maxlength="11"
                       oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                       pattern="[0-9]*"
                       placeholder="手机号" type="number"/>
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd"><label class="weui-label">验证码</label></div>
              <div class="weui-cell__bd">
                <input id="js_input" v-model="verificationCode" autofocus class="weui-input"
                       maxlength="6" pattern="[0-9]*" placeholder="输入验证码"/>
              </div>
              <div class="weui-cell__ft" @click="getSmsCode">{{ isSend ? message : "获取验证码" }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" @click="login">登录</a>
      </div>
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding-top: 36px; padding-bottom: 12px;">
        <a href="https://beian.miit.gov.cn/">粤ICP备19153829号</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Axios from 'axios';

let timer = null;
export default {
  name: "Login",
  data() {
    return {
      phoneNumber: '',
      verificationCode: '',
      isSend: false,
      message: "",
      smsLoading: false
    }
  },
  beforeDestroy() {
    clearInterval(timer);
    timer = null;
  },
  methods: {
    /**
     * 发送验证码
     */
    getSmsCode() {
      if (this.smsLoading) {
        return false
      }
      if (this.phoneNumber == '') {
        alert("请输入手机号");
      } else if (!(/^1[3456789]\d{9}$/.test(this.phoneNumber))) {
        alert("请输入正确的手机号");
      } else {
        let times = 60;
        this.smsLoading = true;
        delete Axios.defaults.headers.common.token;
        axios.post(process.env.VUE_APP_BASE_URL + '/login/getSmsCodeForLogin?phone=' + this.phoneNumber).then(res => {
          if (res.data.code === "0") {
            this.$message({
              message: '发送验证码成功',
              type: 'success'
            });
            this.smsLoading = false;
            this.isSend = true;
            this.message = times + "s";
            timer = setInterval(() => {
              times--;
              this.message = times + "s";
              if (times <= 0) {
                clearInterval(timer);
                timer = null;
                this.isSend = false;
                this.message = "60s";
              }
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(err => {
          this.smsLoading = false;
          console.log(err)
        })
      }
    },
    login: function () {
      if (this.phoneNumber.length !== 11) {
        alert("手机号必须是11位");
        return
      }
      if (this.verificationCode.length < 6) {
        alert("验证码是6位");
        return
      }
      delete Axios.defaults.headers.common.token;
      Axios.defaults.headers.common['authenticationType'] = 'weixin';
      axios.post(process.env.VUE_APP_BASE_URL + '/login',
          JSON.stringify({
            phone: this.phoneNumber,
            verificationCode: this.verificationCode
          }), {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(response => {
        if (response.data.code === '0') {
          localStorage.setItem('token', response.data.token);
          Axios.defaults.headers.common['token'] = response.data.token;
          this.openIssuesPage()
        } else {
          alert(response.data.msg)
        }
      });
    },
    openIssuesPage() {
      this.$router.replace({path: '/browser/issues'})
    },
  },
}
</script>

<style scoped>
.weui-cell__ft {
  color: #07c160;
  font-size: 16px;
}
</style>
